/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import {
  ErrorHandlingService, GLOBAL_API_DEFAULT_TIMEOUT,
  GlobalHttpErrorInterceptor,
  GlobalHttpTimeoutInterceptor,
  HttpWithCredentialsRequestsInterceptor,
  RequestsCacheBustingInterceptor,
} from '@clickd-angular/common-lib';
import { AddCommonQueryStringParamsToMscrmappApisInterceptor } from './add-common-query-string-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: RequestsCacheBustingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpErrorInterceptor, multi: true, deps: [ErrorHandlingService] },
  { provide: GLOBAL_API_DEFAULT_TIMEOUT, useValue: 120000 },
  { provide: HTTP_INTERCEPTORS, useClass: GlobalHttpTimeoutInterceptor, multi: true, deps: [GLOBAL_API_DEFAULT_TIMEOUT] },
  { provide: HTTP_INTERCEPTORS, useClass: HttpWithCredentialsRequestsInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AddCommonQueryStringParamsToMscrmappApisInterceptor, multi: true }
];
